// PABLO ADRIAN GONZALEZ
// 18/04/2018

import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

//services
import { ConfigService } from '../../servicios/config/config.service';
import {KeyService} from '../../servicios/key.service';


@Injectable()

export class SucursalService{
    _key= new KeyService();
    public profesiones:any[] = [];
    PATH = new ConfigService().obtenerPath();

    constructor(private http:Http) {
    }

    ngOnInit()
    {}

    /**
     * Obtener las sucursales que pertenecen aun tercero especifico
     * JMM-2018-09-03
     */
    getSucursales(terceroid)
    {
        let url = this.PATH+'/api/public/list-sucursales/' + terceroid;
        return this.http.get(url,{headers:this._key.head()}).map(resp=>resp.json());
    }// .getSucursales(terceroid)


    list_getsucursal(terceroid){
        let url = this.PATH+'/api/public/list_getsucursal/' + terceroid;
        return this.http.get(url,{headers:this._key.head()}).map(resp=>resp.json());
    }// .list_getsucursal(terceroid)

    /**
     * Obtener informacion de una sucursal especifica
     */
    obtenerSucursal(id)
    {
        let url = this.PATH+'/api/public/sucursales/'+id+'/edit';
        return this.http.get(url,{headers:this._key.head()}).map(resp=>resp.json());
    }// .obtenerSucursal(id)

    /**
     * Permite obtener el listado de sucursales
     * JMM-2019-06-06
     */
    getListSucursales()
    {
        let url = this.PATH+'/api/public/sucursales';
        return this.http.get(url,{headers:this._key.head()}).map(resp=>resp.json());
    }// .getListSucursales()

    /**
     * Obtener las sucursales que pertenecen aun tercero especifico
     * JMM-2019-07-16
     */
    getListareasclubsql(parametro:any)
    {
        let url = this.PATH+'/api/public/listareasclubsql';
        return this.http.post(url, parametro, {headers:this._key.head()}).map( resp => resp.json());
    }// .getListareasclubsql(parametro:any)

 }



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/Terceros/sucursal.service.ts